import React from 'react'
import styled from 'styled-components'
import { Borders, Colors, Fonts, INTEGRAL_SUPPORT_URL } from '../constants'
import { Logo } from '../common'
import { Canvas } from '../common/page/Canvas'

export function BlacklistedWalletBlocker() {
  return (
    <Container>
      <CanvasStyled />
      <Content>
        <LogoStyled />
        <Heading>Integral is unavailable.</Heading>
        <Paragraph>
          We have reason to believe your wallet is associated with The US Treasury's Office of Foreign Assets Control
          ("OFAC") list of Specially Designated Nationals and other persons (which term includes both individuals and
          entities) whose property is blocked (the "SDN List").
        </Paragraph>
        <Paragraph>
          If you believe you've reached this error by mistake please contact{' '}
          <a href={INTEGRAL_SUPPORT_URL} target="_blank">
            support
          </a>
          .
        </Paragraph>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100vh;
  background-color: ${Colors.Background};
`

const CanvasStyled = styled(Canvas)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
`

const Content = styled.div`
  margin: 60px 30px 0 30px;
  padding: 30px;
  max-width: 750px;
  text-align: center;
  color: ${Colors.White};
  background-color: #272b31;
  border: 1px solid #5c5c5c;
  border-radius: ${Borders.Radius};
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  z-index: 1;
`

const LogoStyled = styled(Logo)`
  width: 200px;
`

const Heading = styled.h1`
  font-size: 20px;
  font-family: ${Fonts.Header};
`

const Paragraph = styled.div`
  font-size: 15px;
  text-align: left;

  a {
    color: ${Colors.White};
  }
`
